import { css } from 'lit';

export default css`
    .alarm-status {
        background-color: var(--color-surface-primary);
        border-radius: var(--metrics-radius-s);
        padding: var(--metrics-spacing-s) var(--metrics-spacing-m);
    }

    .alarm-overview {
        display: flex;
        justify-content: space-evenly;
        text-align: center;
        flex-wrap: wrap;
        gap: var(--metrics-spacing-m);
        padding: var(--metrics-spacing-s) 0;
    }

    .status-entry {
        display: flex;
        align-items: center;
        gap: var(--metrics-spacing-s);
    }

    .status-icon-circle {
        display: flex;
        align-items: center;
        justify-content: center;
        width: var(--grid-5);
        height: var(--grid-5);
        border-radius: 50%;
        color: var(--color-icon-primary);
    }

    .status-icon-circle .hmtmobile {
        font-size: var(--font-size-icon-m);
    }

    .alarm-status-alarm {
        border: 1px solid var(--color-classes-outline-alarm);
        background-color: var(--color-classes-fill-alarm);
    }

    .alarm-status-warning {
        border: 1px solid var(--color-classes-outline-warning);
        background-color: var(--color-classes-fill-warning);
    }

    .alarm-status-good {
        border: 1px solid var(--color-classes-outline-good);
        background-color: var(--color-classes-fill-good);
    }

    .status-counter {
        text-align: left;
    }

    .counter-value {
        font-weight: var(--font-weight-head-s);
        font-size: var(--font-size-headline-m);
        color: var(--color-text-primary);
    }

    .counter-label {
        font-size: var(--font-size-body-m);
        font-weight: var(--font-weight-body-m);
        color: var(--color-text-secondary);
    }
`;
